import { render, staticRenderFns } from "./host-common-label.vue?vue&type=template&id=e425d572&scoped=true&"
import script from "./host-common-label.vue?vue&type=script&lang=js&"
export * from "./host-common-label.vue?vue&type=script&lang=js&"
import style0 from "./host-common-label.vue?vue&type=style&index=0&id=e425d572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e425d572",
  null
  
)

export default component.exports